import {
  configureScope as sentryConfigureScope,
  init as sentryInit
} from '@sentry/browser';
import { CaptureConsole } from '@sentry/integrations';

import { getEnvironmentVariables } from 'utility/environment';
import { isServer } from 'utility/isServer';
import { beforeSend } from 'utility/sentryUtils';

type DefaultProps = {
  // eslint-disable-next-line unused-imports/no-unused-vars
  addSmartlookUrlToEvent?: (...args: any[]) => { extra?: any };
  initializeSentry?: () => any;
};

const _default: DefaultProps = {};

const addSmartlookUrlToEvent = (event: { extra?: any }) => {
  if (event.extra == null) {
    event.extra = {};
  }

  // Build the URL to the session recording
  let sessionRecordingUrl = 'not available';
  if (
    !isServer() &&
    (window as any).smartlook &&
    (window as any).smartlook.playUrl
  ) {
    sessionRecordingUrl = (window as any).smartlook.playUrl;
  }

  event.extra.sessionRecordingUrl = sessionRecordingUrl;

  return event;
};
_default.addSmartlookUrlToEvent = addSmartlookUrlToEvent;

export const initializeSentry = () => {
  const { ENVIRONMENT_NAME, SENTRY_DSN, ENABLE_SENTRY, BUILD_ID } =
    getEnvironmentVariables();

  // Converting to a string so we only have to deal with one type between client and server side
  if (String(ENABLE_SENTRY) !== 'true') {
    return;
  }

  sentryInit({
    dsn: SENTRY_DSN,
    debug: false,
    release: BUILD_ID,
    environment: ENVIRONMENT_NAME,
    sampleRate: 1.0,
    maxBreadcrumbs: 100,
    normalizeDepth: 3,
    integrations: [
      new CaptureConsole({
        levels: ['error']
      })
    ],
    ignoreErrors: [
      `Can't find variable: jQuery`,
      'jQuery is not defined',
      'Route did not complete loading'
    ],
    beforeSend
  });

  sentryConfigureScope(scope => {
    scope.addEventProcessor(addSmartlookUrlToEvent);
  });
};

_default.initializeSentry = initializeSentry;

export default _default;
